// extracted by mini-css-extract-plugin
export var contactField = "Contact-module--contactField--kEgaP";
export var contactFinField = "Contact-module--contactFinField--876bT";
export var textareaErrorBudge = "Contact-module--textareaErrorBudge--I4Hpm";
export var errorBudge = "Contact-module--errorBudge--lAl1t";
export var returnButton = "Contact-module--returnButton---9b6N";
export var homeLink = "Contact-module--homeLink--Ta4YW";